import React, { useState, useEffect, useRef } from 'react';
import { useRecoilState } from 'recoil';
import { userState } from '../../stores/atoms';
import { awsInstance } from "../../actions/api";
import Loading from "./../Loading";
import PrivacyPolicy from './PrivacyPolicy';

function AddUser({ isLogined, history, match }) {
	const id = match.params.id;
	const [, setUser] = useRecoilState(userState);
	const [isAgree, setIsAgree] = useState(false);
	const [loading, setLoading] = useState(false);
	const submitButtonRef = useRef();
	
	useEffect(() => {
		submitButtonRef.current.disabled = !isAgree;
		// eslint-disable-next-line
	}, [isAgree]);

	if (isLogined) {
		setUser(null);
    	sessionStorage.removeItem('user');
	}

	const onFormSubmit = async event => {
		event.preventDefault();
		try {
			setLoading(true);
			const { data } = await awsInstance.post('business/employee/sign-up', { id }); // 회원가입 API

			if (data.code != 'SUCCESS') {
				alert('직원 인증이 실패하였습니다.');
				return;
			}
			alert('직원 인증이 성공하였습니다.');
			history.push('/add-user-done');
		} catch (e) {
			alert(e);
		} finally {
			setLoading(false);
		}
	}

	return (
		<>
			<div className="register">
				<h3>직원 인증</h3>
				<br />
				<PrivacyPolicy />
				<br />
				<form className="register-form" onSubmit={onFormSubmit}>
					<div className="input-area">
						<input
							id="agreeCheck"
							type="checkbox"
							onChange={event => setIsAgree(event.target.checked)}
							required />
						<label className="form-check-label" htmlFor="agreeCheck">
							&nbsp;개인정보 처리방침을 확인하였고, 이에 동의합니다.
						</label>
					</div>
					<button className="form-control btn btn-lg submit-btn active mt-4" type="submit" ref={submitButtonRef}>인증하기</button>
				</form>
			</div>
			<Loading loading={loading} /> 
		</>
	);
}

export default AddUser;
